<template>
  <div class="home">
    <EditAccountDetailPage />
  </div>
</template>

<script>
import EditAccountDetailPage from '../components/elements/pages/EditAccountDetailPage.vue'
export default {
  name: 'EditAccountDetails',
  metaInfo: {
    title: 'Edit My Account Detail'
  },
  components: {
    EditAccountDetailPage
  }
}
</script>
<style scoped lang="less">
@import (reference) "~@/assets/css/variables.less";
section.home-hero {
  background-size: 100% 100%;
  padding: 0;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
  }
}
</style>
